import type { BannerSwapQueueRequest } from "../utils/@types";

/** JSON body for POST /BannerSwap/Queue (ISO date strings over the wire). */
export type BannerSwapQueueWireBody = Omit<
  BannerSwapQueueRequest,
  "startDate" | "endDate"
> & {
  startDate: string | "immediate";
  endDate: string | "permanent";
};

/** Ensure queue POST body matches server Joi (ISO dates + overlapResolution). */
export function normalizeBannerSwapQueueRequest(
  swap: BannerSwapQueueRequest
): BannerSwapQueueWireBody {
  const startDate: BannerSwapQueueWireBody["startDate"] =
    swap.startDate instanceof Date
      ? swap.startDate.toISOString()
      : swap.startDate;
  const endDate: BannerSwapQueueWireBody["endDate"] =
    swap.endDate instanceof Date ? swap.endDate.toISOString() : swap.endDate;

  return {
    ...swap,
    startDate,
    endDate,
    ...(swap.overlapResolution
      ? { overlapResolution: swap.overlapResolution }
      : {}),
  };
}
